import "./RelatedDealsPanel.css";

import { Column, CursorDataGrid, Row } from "../../../../../../widget";
import { useRelatedDealsPanel } from "./useRelatedDealsPanel";

interface RelatedDealsPanelProps {
  workflowTemplateUuid?: string;
}

export const RelatedDealsPanel = ({ workflowTemplateUuid }: RelatedDealsPanelProps): JSX.Element => {
  const { onChange, columns, refresh, isLoading, relatedDealsPanelRef } = useRelatedDealsPanel({
    workflowTemplateUuid,
  });

  return (
    <div ref={relatedDealsPanelRef} className="RelatedDealsPanel">
      <Row spacingV="ll">
        <Column span={6}>
          <h2>Related deals</h2>
        </Column>
      </Row>
      <Row>
        <Column span={12}>
          {workflowTemplateUuid ? (
            <CursorDataGrid
              data={[]}
              columns={columns}
              clientSide={false}
              onChange={onChange}
              filterable
              dataIsLoading={isLoading}
              noDataMessage="No related deals to display"
              refresh={refresh}
            />
          ) : (
            <p className="body1">Select a workflow to show related deals</p>
          )}
        </Column>
      </Row>
    </div>
  );
};
